/* ═══════════════════════════════════════════════════
   TrackLab v2 — Today's Races view: Next to run / By course
   ?view= wins and is remembered in localStorage, like the detail toggle.
   With no ?view= the server renders the default (course); a saved choice
   that differs from it ("next") is applied by reloading once with ?view=next.
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  var STORAGE_KEY = 'tl_races_view';
  var VIEWS = ['next', 'course'];

  TL.racesView = {};

  function valid(v) {
    return VIEWS.indexOf(v) !== -1 ? v : null;
  }

  TL.racesView.fromUrl = function () {
    var m = /[?&]view=([^&#]*)/.exec(window.location.search);
    return m ? valid(m[1]) : null;
  };

  TL.racesView.get = function () {
    try {
      return valid(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  };

  TL.racesView.save = function (view) {
    if (!valid(view)) return;
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (e) { /* storage blocked: the choice just isn't remembered */ }
  };

  TL.racesView.init = function () {
    var toggle = document.getElementById('v2ViewToggle');
    if (!toggle) return;

    var shown = valid(toggle.getAttribute('data-view'));
    var fromUrl = TL.racesView.fromUrl();
    if (fromUrl) {
      TL.racesView.save(fromUrl);
    } else {
      var saved = TL.racesView.get();
      if (saved && saved !== shown) {
        var url = new URL(window.location.href);
        url.searchParams.set('view', saved);
        window.location.replace(url.pathname + url.search + url.hash);
        return;
      }
    }

    toggle.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[data-view]') : null;
      if (link) TL.racesView.save(link.getAttribute('data-view'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', TL.racesView.init);
  } else {
    TL.racesView.init();
  }
})();
